import { endOfDay, startOfDay } from "date-fns";
import {
  Request,
  RequestFilters,
  RequestStatus,
  RequestType,
} from "@/types/request";

export const buildDashboardGuestRequestsListFilters = (
  hotelId: string,
): RequestFilters => ({
  type: RequestType.GUEST,
  hotelId,
  limit: 500,
  sortField: "createdAt",
  sortDirection: "desc",
});

export const isGuestRequestCreatedToday = (
  request: Request,
  ref: Date = new Date(),
): boolean => {
  if (request.type !== RequestType.GUEST || !request.createdAt) {
    return false;
  }
  const t = new Date(request.createdAt).getTime();
  return t >= startOfDay(ref).getTime() && t <= endOfDay(ref).getTime();
};

export const countGuestRequestsCreatedToday = (
  requests: Request[],
  ref: Date = new Date(),
): number => requests.filter((r) => isGuestRequestCreatedToday(r, ref)).length;

export const isGuestRequestCompletedToday = (
  request: Request,
  dayStart: Date,
  dayEnd: Date,
): boolean => {
  if (request.type !== RequestType.GUEST) {
    return false;
  }
  const tasks = request.tasks ?? [];
  if (tasks.length === 0) {
    return false;
  }
  const allDone = tasks.every((task) => task.status === RequestStatus.DONE);
  if (!allDone) {
    return false;
  }
  const latestUpdate = Math.max(
    ...tasks.map((task) => new Date(task.updatedAt).getTime()),
  );
  return latestUpdate >= dayStart.getTime() && latestUpdate <= dayEnd.getTime();
};

export const countGuestRequestsCompletedToday = (
  requests: Request[],
  ref: Date = new Date(),
): number => {
  const dayStart = startOfDay(ref);
  const dayEnd = endOfDay(ref);
  return requests.filter((r) =>
    isGuestRequestCompletedToday(r, dayStart, dayEnd),
  ).length;
};
